<div class="tt-page-not-found">
  <mat-icon class="tt-page-not-found_icon" [icon]="'no-results'" [iconSize]="260" />
  <span class="tt-page-not-found_error">404</span>
  <span class="tt-page-not-found_title">{{ 'PageNotFound.Title' | transloco }}</span>
  <span class="tt-page-not-found_message">{{ 'PageNotFound.Message' | transloco }}</span>
</div>
